export const updateProps = (type) => `UPDATE_PROPS_IN_MESSAGING_${type.toUpperCase()}`;

export const LOADING_LIST = '[inbox]LOADING_CONVERSATION_LIST';
export const LIST_LOADED = '[inbox]CONVERSATION_LIST_LOADED';

export const LOADING_MSGS = '[inbox]LOADING_MSGS_IN_MESSAGING';
export const MSGS_LOADED_INITIALLY = '[inbox]MSGS_LOADED_INITIALLY_IN_MESSAGING';


export const CREATING_CONTRACT = '[inbox]CREATING_CONTRACT_IN_MESSAGING';
export const CONTRACT_CREATED = '[inbox]CONTRACT_CREATED_IN_MESSAGING';
export const CREATE_CONTRACT_FAILED = '[inbox]CREATE_CONTRACT_FAILED_IN_MESSAGING';

export const TOGGLE_CONV_DONESS = '[inbox]TOGGLE_CONV_DONESS_IN_MESSAGING';
export const TOGGLE_CONV_DONESS_SUCCESS = '[inbox]TOGGLE_CONV_DONESS_IN_MESSAGING_SUCCESS';

export const GET_PARTNERS = '[inbox]GET_PARTNERS';



// WEBPACK FOOTER //
// ./src/app/components/messaging/messagingStore/messaging-constants.js